import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.from";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.for-each";
import './polyfill'; // import stickybits from 'stickybits';
//
// import MobileMenu from './components/MobileMenu';

import MainNavigation from './components/MainNavigation';
import ToggleableComponent from './components/ToggleableComponent'; // import {
//   debounce,
//   toTop
// } from './library';
// import { SCROLL_DEBOUNCE } from "./constants";

(function (Drupal, $) {
  //Global Project Variables and elements
  // const MAIN_MENU = document.querySelector('#block-mainnavigation .menu'); //main menu
  // const Burger_Button = document.getElementById('burger-icon'); // burger icon
  // //This object is used store settings for mobile menu
  // const MOBILE_MENU_SETTINGS = {
  //   element: Burger_Button,
  //   menu: MAIN_MENU,
  //   direction: 'right', //options are left and right
  // };
  //
  // //The variance in when the function on the scroll listener will fire
  // const SCROLL_DEBOUNCE = 5;
  // //The variance in when the function on the resize listener will fire
  // const RESIZE_DEBOUNCE = 5;
  //Use this to interact with drupal behaviors module
  Drupal.behaviors.main = {
    attach: function attach(context, settings) {
      /** Disable the click of job-listings table */
      var jobListings = document.querySelector('.block-job-listings-block');

      if (jobListings) {
        var links = jobListings.querySelectorAll('td a');
        Array.from(links).forEach(function (link) {
          link.addEventListener('click', function (e) {
            e.preventDefault();
          });
        });
      } // -------------
      // Accordion Toggle


      var accordions = document.querySelectorAll('.paragraph--accordion-item');
      accordions.forEach(function (accordion) {
        var accordionToggle = new ToggleableComponent(accordion.querySelector('.field-title'), accordion);
      });
      var searchFormToggle = new ToggleableComponent(document.querySelector('.region-header .search-icon'), document.querySelector('.region-header .search-form-wrapper'));
      var mobileMenu = new ToggleableComponent(document.querySelector('.region-header .menu-icon'), document.querySelector('.menu--main > .menu')); // Search form toggle callback.

      searchFormToggle.toggleCallback = function (toggled) {
        var _this = this;

        // Event listener when clicking outside of the box to close it.
        var outsideSearchClickListener = function outsideSearchClickListener(event) {
          if (!_this.button.parentElement.contains(event.target) && _this._toggled) {
            _this.deactivate();

            removeClickListener();
          }
        };

        var removeClickListener = function removeClickListener() {
          document.removeEventListener('click', outsideSearchClickListener);
        };

        if (toggled) {
          // Close mobile menu if search opened.
          mobileMenu.deactivate(); // Focus search input.

          this.component.querySelector('input').focus(); // Add outside click listener.

          document.addEventListener('click', outsideSearchClickListener);
        } else {
          // Remove outside click listener.
          removeClickListener();
        }
      }; // Mobile menu toggle callback.


      mobileMenu.toggleCallback = function (toggled) {
        if (toggled) {
          // Close search if mobile menu opened.
          searchFormToggle.deactivate();
        }
      }; // Contact page


      var learnMoreButton = document.querySelector('.learn-more');

      if (learnMoreButton) {
        learnMoreButton.addEventListener('click', function () {
          if (learnMoreButton.classList.contains('active')) {
            learnMoreButton.classList.remove('active');
            return;
          }

          learnMoreButton.classList.add('active');
        });
      } // -------------
      // Accordion Toggle


      var contact_accordions = document.querySelectorAll('.paragraph--type--contact-accordion-item');
      contact_accordions.forEach(function (accordion) {
        new ToggleableComponent(accordion.querySelector('.field-title'), accordion);
      });
    } //end of inherited context and settings from drupal

  }; //end of drupal behaviors

  /* global Javascript */

  new MainNavigation('.menu--main > .menu');
})(Drupal, jQuery); //end of drupal and jQuery closure